import React, { useState } from "react";
import CheckSVG from "../assets/SVG/icons/check.svg";
import _ from "lodash";
import "../styles/product.css";

const BuyAgain = "Buy Again";

const Product = ({
  onCancelSubscribe = _.noop,
  onSubscribe = _.noop,
  subscribeCtaText = "Select",
  productName = "Product Name",
  disableSubscribe = false,
  amount = 10000,
  interval = "Month",
  intervalCount = 0,
  productDescription = "Some Product descriptions",
  features = [
    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
    "Aliquam tincidunt mauris eu risus.",
    "Vestibulum auctor dapibus neque.",
    "Nunc dignissim risus id metus.",
    "Cras ornare tristique elit.",
    "Aliquam tincidunt mauris eu risus.",
    "Vestibulum auctor dapibus neque.",
  ],
  stripeCustomerId,
  priceId,
  uid,
  subscription,
  pendingPayment,
  product,
  coupon,
  testCounts,
  selectedPriceId,
  showCTA,
  lastUpdated,
  showCancelCta,
  activeProduct,
  isAutoRenewal = true,
  showAutoRenewal = true,
}) => {
  const onSubscribeHandle = () => {
    onSubscribe(stripeCustomerId, priceId, uid, product, product?.isOneTime, testCounts);
  };
  const onSubscribeCancelHandle = () => {
    onCancelSubscribe(subscription);
  };

  const planIdFromSubscription = subscription?.stripe?.plan?.id;
  const isCancelAtPeriodEnd = subscription?.stripe?.cancel_at_period_end && planIdFromSubscription === priceId;

  const afterCoupen = coupon?.percent_off
    ? Math.floor(amount - (amount * coupon?.percent_off) / 100) / 100
    : (amount - coupon?.amount_off) / 100;

  const generateSubscribeLabel = () => {
    if (planIdFromSubscription === priceId && subscription?.stripe?.status === "incomplete") {
      return "Pending";
    }
    if (planIdFromSubscription === priceId && subscription?.stripe?.status === "active") {
      if (product?.isOneTime) return BuyAgain;
      return "Renew";
    }
    if (planIdFromSubscription === priceId && subscription?.stripe?.cancel_at_period_end) {
      return "ReSubscribe";
    }
    return subscribeCtaText;
  };

  const isActivePlan = planIdFromSubscription === priceId && subscription?.stripe?.status === "active";

  const isSubCtaDisabled = () => {
    const ctaLabel = generateSubscribeLabel();
    if (ctaLabel === "Pending") return true;
    // if (product?.isOneTime) return false;
    // return planIdFromSubscription === priceId;
  };
  return (
    <div
      data-productname={productName}
      className={`product-item ${activeProduct} interval-${intervalCount} ${planIdFromSubscription === priceId ? "active-product" : ""}`}
      data-testid="product-component"
    >
      <div className="product-info">
        <div className="product-name">{productName}</div>
        <div className="product-summary">{productDescription}</div>
        <div className="product-price">
          {coupon ? (
            <span className="actual-amount">${parseFloat(afterCoupen).toFixed(2)} </span>
          ) : (
            <span className="actual-amount">${parseFloat(amount / 100).toFixed(2)}</span>
          )}
          {product?.isOneTime ? (
            <span className="per-test">a Test</span>
          ) : (
            <span className="per-month">
              / {intervalCount} {interval}
            </span>
          )}
        </div>
        {coupon ? (
          <div className="product-before-price">
            Was{" "}
            <span style={{ textDecorationLine: "line-through", fontSize: "large" }}>
              ${parseFloat(amount / 100).toFixed(2)}{" "}
            </span>{" "}
          </div>
        ) : (
          <div className="product-before-price">&nbsp;</div>
        )}
        {isAutoRenewal && showAutoRenewal && <div className="auto-renew">Auto-renewal is enabled</div>}
        {!isAutoRenewal && showAutoRenewal && <div className="auto-renew">Auto-renewal is disabled</div>}
      </div>

      <div className="product-cta-and-features">
        {showCTA && activeProduct === "covid" && (
          <div className="product-subcribe">
            <button
              className={`sub-button ${generateSubscribeLabel()}`}
              disabled={selectedPriceId === priceId ? true : isSubCtaDisabled()}
              onClick={onSubscribeHandle}
            >
              {generateSubscribeLabel()}
            </button>
          </div>
        )}
        {!isCancelAtPeriodEnd && (
          <div className="product-subcribe">
            <button
              className={`sub-button ${generateSubscribeLabel()}`}
              disabled={selectedPriceId === priceId ? true : isSubCtaDisabled()}
              onClick={onSubscribeHandle}
            >
              {generateSubscribeLabel()}
            </button>
          </div>
        )}

        {isCancelAtPeriodEnd && (
          <>
            <div>This plan is pending cancellation.</div>
            <div className="product-subcribe">
              <button
                className={`sub-button ${generateSubscribeLabel()}`}
                disabled={selectedPriceId === priceId ? true : isSubCtaDisabled()}
                onClick={onSubscribeHandle}
              >
                ReSubscribe
              </button>
            </div>
          </>
        )}

        {isActivePlan && !isCancelAtPeriodEnd && showCancelCta && (
          <div className="product-cancel">
            <button className="cancel-sub-button" onClick={onSubscribeCancelHandle}>
              Cancel
            </button>
          </div>
        )}
        <div className="benefit-container">
          <ul className="features">
            {features.map((item, index) => (
              <li key={index}>
                <img src={CheckSVG} alt="check" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Product;
